import { MeetingUid } from 'components/features/coaching/advisorPage/types/interfaces'
import { MeetingVideoDetailsApiOutput } from 'components/features/coaching/advisorVideoCall/types/state'
import { createRequestAction } from 'helpers/actionHelpers/createRequestAction'
import { createAction } from 'helpers/actionHelpers/createAction'

export class GetMeetingVideoDetailsAction extends createRequestAction<'GET_MEETING_VIDEO_DETAILS', {
  meetingId: MeetingUid
}, MeetingVideoDetailsApiOutput>('GET_MEETING_VIDEO_DETAILS') {}

export class RefreshMeetingRemainTimeAction extends createAction<'REFRESH_MEETING_REMAIN_TIME', { start_time: string }>('REFRESH_MEETING_REMAIN_TIME') {}

export class FinishMeetingAction extends createAction<'FINISH_MEETING', void>('FINISH_MEETING') {}

export type AdvisorVideoCallActions =
  | typeof GetMeetingVideoDetailsAction.Type
  | RefreshMeetingRemainTimeAction
  | FinishMeetingAction
